<template>
  <WdsButtonGhost
    v-if="column.hire"
    secondary
    :href="hirePath"
    :title="jobTitle"
    class="tw-max-w-[310px] tw-min-h-[46px]"
  >
    <WdsStack class="hire-column" direction-column justify-center>
      <span class="tw-text-[#5d36f1]">
        {{ jobTitle }}
      </span>
    </WdsStack>
  </WdsButtonGhost>
  <div v-else class="tw-flex tw-flex-col tw-items-start tw-justify-center">
    <WdsText>{{ $t('No hire') }}</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsStack, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const PaymentRequestHireColumnClient = graphql(`
  fragment PaymentRequestHireColumnClient on PaymentRequest {
    id
    hire {
      id
      number
      activeContract {
        id
        jobName
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestHireColumnClient>
}>()

const { $t } = useTranslation()

const column = computed(() => useFragment(PaymentRequestHireColumnClient, props.row))

const jobTitle = computed(() => column.value.hire?.activeContract?.jobName || $t('No job assigned'))

const hirePath = computed(() =>
  column.value.hire?.id
    ? laravelNamedRoute(namedRoutes.hires.hire.view, {
        hire: column.value.hire.id,
        tab: 'overview',
      })
    : '#',
)
</script>

<style lang="scss" scoped>
.hire-column {
  max-width: 300px;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
}
</style>
